import { render, staticRenderFns } from "./PortalDesigner.vue?vue&type=template&id=e91fd702&"
import script from "./PortalDesigner.vue?vue&type=script&lang=js&"
export * from "./PortalDesigner.vue?vue&type=script&lang=js&"
import style0 from "./PortalDesigner.vue?vue&type=style&index=0&id=e91fd702&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e91fd702')) {
      api.createRecord('e91fd702', component.options)
    } else {
      api.reload('e91fd702', component.options)
    }
    module.hot.accept("./PortalDesigner.vue?vue&type=template&id=e91fd702&", function () {
      api.rerender('e91fd702', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/bespoke/pageDesigner/PortalDesigner.vue"
export default component.exports